import React from 'react'
import { Content } from './style'
import { Outlet, useNavigate, useOutletContext, useLocation } from 'react-router-dom'
import { useTenant } from '../../../contexts/TenantContext'
import { TypeMainOutlet } from '..'
import stock from '../../../assets/stock/TableMovementHeader/list-active.svg'
import resource from '../../../assets/home/resource.svg'
import { resourceFilterHeaders } from '../Stock'
import { usePersistedFilters } from '../../../hooks/usePersistedFilters'
import { PageHeader } from '../../../components/StandardPage'

export interface Resources {
  tabIndex: number
}

const tabs = [
  { path: '/panel/stock', image: stock, name: 'Matéria prima' },
  { path: '/panel/resource', image: resource, name: 'Insumos' }
]

const getActiveIndex = (pathname: string) => {
  if (pathname.includes('/panel/resource')) return 1
  return 0
}

const ResourcesContent = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { isFashionTenant } = useTenant()
  const context = useOutletContext<TypeMainOutlet>()
  const search = context?.search || ''
  const [refresh, setRefresh] = React.useState(false)

  const {
    appliedFilters,
    handleApplyFilter,
    handleRemoveFilter,
    handleClearAll
  } = usePersistedFilters('steel_resource')

  const filteredHeaders = resourceFilterHeaders.filter(header =>
    isFashionTenant ? true : header.key !== 'color'
  )

  const tabIndexActived = getActiveIndex(location.pathname)

  return (
    <>
      <PageHeader
        title='Insumos'
        tableName='Resource'
        moduleName='Insumos'
        tabs={tabs.map((tab, index) => ({ key: String(index), label: tab.name, icon: tab.image }))}
        activeTab={String(tabIndexActived)}
        onTabChange={(key) => {
          const index = Number(key)
          if (index !== tabIndexActived) navigate(tabs[index].path)
        }}
        onReload={() => setRefresh(prev => !prev)}
        filterHeaders={filteredHeaders}
        onApplyFilter={handleApplyFilter}
        appliedFilters={appliedFilters}
        onRemoveFilter={handleRemoveFilter}
        onClearAllFilters={handleClearAll}
        createButton={{ label: 'Adicionar Insumo', onClick: () => navigate('create') }}
      />
      <Content>
        <Outlet context={{ search, appliedFilters, refresh }} />
      </Content>
    </>
  )
}

export default ResourcesContent
